var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center","justify":"space-around"}},[_c('sign-in')],1)}
var staticRenderFns = []

export { render, staticRenderFns }